export default __webpack_public_path__ + "static/media/madero.9a86937a.png";